export default class Dropdown {
	constructor() {
		this.dropdownGroups = document.querySelectorAll(".jsDropdown");
		this.dropdownContents = document.querySelectorAll(".jsDropdownContent");
		this.body = document.body;
		this.events();
	}

	events() {
		const th = this;
		if (this.dropdownGroups) {
			this.dropdownGroups.forEach(function (dropdown) {
				const dropdownBtn = dropdown.querySelector(".jsDropdownButton");
				const dropdownContent = dropdown.querySelector(".jsDropdownContent");

				if (!dropdownBtn.classList.contains("triggered")) {
					dropdownBtn.addEventListener("click", function (e) {
						e.preventDefault();
						th.displayDropdown(dropdownContent);
					});
				}

				dropdownBtn.classList.add("triggered");
			});
		}

		window.addEventListener("click", function (e) {
			if (this.dropdownContents) {
				this.dropdownContents.forEach(function (dropdownContent) {
					if (!(dropdownContent.parentElement.contains(e.target) && dropdownContent.classList.contains("is-open"))) {
						dropdownContent.classList.remove("is-open");
					}
				});
			}
		});
	}

	displayDropdown(dropdownContent) {
		if (dropdownContent.classList.contains("is-open")) {
			dropdownContent.classList.remove("is-open");
		} else {
			dropdownContent.classList.add("is-open");
		}
	}

	hideDropdown(e) {
		e.preventDefault();
		const parent = this.closest(".dropdown");
		if (parent.classList.contains("is-open")) {
			parent.classList.remove("is-open");
		}
	}
}
